import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { DataSolicitudItinerarioProy } from '../../interfaces/DataBsqProy';
import { HiOutlineDocumentSearch } from 'react-icons/hi';
import { Card, CardActionArea, CardContent, Grid, IconButton, List, ListItem, ListItemText, Tooltip, Typography } from '@mui/material';
import { format } from 'date-fns';
import { MdEditNote, MdDeleteForever } from "react-icons/md";
import ItinerarioService from '../../services/ItinerarioService';
import { SolicitudItinerarioDTO, VoidSolicitudItinerarioDTO } from '../../interfaces/Itinerario/SolicitudItinerarioDTO';
import { FaRegEdit } from "react-icons/fa";
import { SetSolicitudEstudianteItinerarioDTO, SolicitudEstudianteItinerarioDTO, VoidSolicitudEstudianteItinerarioDTO } from '../../interfaces/Itinerario/SolicitudEstudianteItinerarioDTO';
import { SmallModal } from '../Common/SmallModal';
import { CasUserContext, useCasUserContext } from '../../services/casUserContext';
import AlertService from '../../services/AlertService';
import { EstudianteActivoDTO, VoidEstudianteActivoDTO } from '../../interfaces/SAAC/EstudianteActivoDTO';
import AcademicoService from '../../services/AcademicoService';
import { ItinerarioForm } from '../Itinerario/ItinerarioForm';
import { Button } from 'reactstrap';

interface Column {
  id: 'matricula' | 'nombre' | 'carrera' | 'profesor' | 'termino' | 'fecha' | 'estado' | 'opciones';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: 'matricula', label: 'Matrícula', minWidth: 100 },
  { id: 'nombre', label: 'Nombre', minWidth: 170 },
  { id: 'carrera', label: 'Carrera', minWidth: 90 },
  { id: 'profesor', label: 'Profesor', minWidth: 170 },
  { id: 'termino', label: 'Término', minWidth: 100 },
  {
    id: 'fecha',
    label: 'Fecha',
    minWidth: 85,
  },
  {
    id: 'estado',
    label: 'Estado',
    minWidth: 100,
  },
  {
    id: 'opciones',
    label: 'Opciones',
    minWidth: 100,
  },
];

interface Data {
  name: string;
  code: string;
  population: number;
  size: number;
  density: number;
}

function createData(
  name: string,
  code: string,
  population: number,
  size: number,
): Data {
  const density = population / size;
  return { name, code, population, size, density };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    zIndex: 0,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    zIndex: -1,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const itinerarioService = new ItinerarioService();
const alertaService = new AlertService();
const academicoService = new AcademicoService();

export default function BusqSolicitudItinerarioProyTable(props: DataSolicitudItinerarioProy) {
  let history = useNavigate()
  //const casUserContext = React.useContext(CasUserContext);
  const casUserContext = useCasUserContext();
  const token = casUserContext.token;
  let [estudiante, setEstudiante] = React.useState<EstudianteActivoDTO>(VoidEstudianteActivoDTO());
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(props.rowsPerPage[0]);
  const [isModalDetalle, setIsModalDetalle] = React.useState<boolean>(false);
  const [isModalEditar, setIsModalEditar] = React.useState<boolean>(false);
  const [isModalEliminar, setIsModalEliminar] = React.useState<boolean>(false);
  const [detalleData, setDetalleData] = React.useState<SolicitudEstudianteItinerarioDTO>(VoidSolicitudEstudianteItinerarioDTO());

  //#region Funciones 
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const goToNavigation = (site: string) => {
    history(site)
  }
  const handleResponseForm = async (responseData: SolicitudEstudianteItinerarioDTO) => {
    // Manejar la respuesta aquí
    setIsModalEditar(false);
    if (responseData.itinerario) {
      alertaService.alertaExito("éxito", "Se creado la nueva solicitud");
      const timer = setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  };
  const handleSearchDetalle = async (id: number) => {
    try {
      await itinerarioService.GetSolicitudItinerarioById(props.token, id)
        .then((data) => {
          if (data.status.isSuccessfully) {
            console.log(data.data);
            setDetalleData(data.data);
            consultarEstudiante(data.data.itinerario.codEstudiante);
          } else {
            setDetalleData(VoidSolicitudEstudianteItinerarioDTO());
          }
        })
        .catch((error) => {
          console.error(error)
        });
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const EliminarItinerario = (id: number) => {
    //console.log(id);
    setIsModalEliminar(false);
    alertaService.showLoading('Espere...')
    itinerarioService.DeleteSolicitudEstudianteItinerario(id, token)
      .then((data) => {
        alertaService.hideLoading()
        if (data.status.isSuccessfully) {
          alertaService.alertaExito("Éxito", "Se elimino la solicitud");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          alertaService.alertaAdvertenciaList("Alerta", data.status.messages);
        }
      }).catch((error) => {
        console.error(error)
        alertaService.hideLoading()
        alertaService.alertaAdvertencia("Alerta", "No se completo el proceso")
      });
  }
  async function consultarEstudiante(codestudiante: string) {
    const resp = await academicoService.GetCarreraActivaByMatricula(token, codestudiante, 'I');
    if (resp.status.isSuccessfully) {
      //console.log(resp.data);
      setEstudiante(resp.data);
    } else {
      console.error(resp.status.messages)
    }
  }
  const handleOpenModalEditar = async (data: SolicitudItinerarioDTO) => {
    await handleSearchDetalle(data.idSolicitud);
    setIsModalEditar(true);
  };
  const handleCloseModalEditar = () => {
    setIsModalEditar(false);
  };
  const handleOpenModalDetalle = async (data: SolicitudItinerarioDTO) => {
    await handleSearchDetalle(data.idSolicitud);
    //console.log(detalleData)
    setTimeout(() => {
      setIsModalDetalle(true);
    }, 1000);
  };
  const handleCloseModalDetalle = () => {
    setIsModalDetalle(false);
  };
  const handleOpenModalEliminar = async (data: SolicitudItinerarioDTO) => {
    await handleSearchDetalle(data.idSolicitud);
    //console.log(detalleData)
    setTimeout(() => {
      setIsModalEliminar(true);
    }, 1000);
  };
  const handleCloseModalEliminar = () => {
    setIsModalEliminar(false);
  };
  function DentroPeriodoItinerarias(): boolean {
    let bandera = false;
    const today = new Date();
    if (props.fechasItinerario.estado === 1) {
      const fechaInicio = new Date(props.fechasItinerario.fechaAperturaTesis);
      const fechaFin = new Date(props.fechasItinerario.fechaCierreTesis);
      bandera = today >= fechaInicio && today <= fechaFin;
    }
    return bandera;
  }
  function PeriodoActual(data: SolicitudItinerarioDTO) {
    let bandera = data.termino === props.periodoActivo.termino + "-" + props.periodoActivo.anio;
    return bandera;
  }
  //#endregion
  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', minHeight: '50vh' }}>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <StyledTableCell
                  style={{ minWidth: column.minWidth }}
                  key={column.id}
                  align={column.align}>
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.length > 0 ? props.data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <StyledTableRow key={row.idSolicitud}>
                    <StyledTableCell component="th" scope="row">
                      {row.matricula}
                    </StyledTableCell>
                    <StyledTableCell align="left">{row.nombreEstudiante}</StyledTableCell>
                    <StyledTableCell align="left">{row.facultad}, {row.carrera}</StyledTableCell>
                    <StyledTableCell align="left">{row.nombreProfesor}</StyledTableCell>
                    <StyledTableCell align="left">{row.termino}</StyledTableCell>
                    <StyledTableCell align="left">{row.fechaSolicitud ? format(new Date(row.fechaSolicitud), 'dd/MMM/yyyy') : "Fecha no disponible"}</StyledTableCell>
                    <StyledTableCell align="left">{row.estadoTexto}</StyledTableCell>
                    <StyledTableCell align="left">
                      <Grid>
                        {PeriodoActual(row) && DentroPeriodoItinerarias() && row.estado !== 'I' ?
                          <Tooltip title={"Editar"} placement="top" arrow >
                            <IconButton aria-label="Editar" color="primary" onClick={() => { handleOpenModalEditar(row) }}>
                              <FaRegEdit />
                            </IconButton>
                          </Tooltip>
                          :
                          <Tooltip title={"Detalle"} placement="top" arrow >
                            <IconButton aria-label="Detalle" color="primary" onClick={() => { handleOpenModalDetalle(row) }}>
                              <HiOutlineDocumentSearch />
                            </IconButton>
                          </Tooltip>
                        }
                        {PeriodoActual(row) && DentroPeriodoItinerarias() && row.estado !== 'I' ?
                          <Tooltip title={"Eliminar"} placement="top" arrow >
                            <IconButton aria-label="Eliminar" color="error" onClick={() => { handleOpenModalEliminar(row) }}>
                              <MdDeleteForever />
                            </IconButton>
                          </Tooltip>
                          : <></>
                        }
                      </Grid>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              }) :
              <StyledTableRow key={0}>
                <StyledTableCell component="th" scope="row"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left">{'Sin resultados'}</StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
              </StyledTableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={props.rowsPerPage}
        component="div"
        count={props.data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <SmallModal
        title='Detalle Solicitud'
        open={isModalDetalle}
        onClose={handleCloseModalDetalle}
        content={<>{detalleData.TituloProyecto !== ''
          ?
          <Card sx={{ margin: 2 }}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                {detalleData.TituloProyecto}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                Código del Proyecto: {detalleData.codigoProyecto}
              </Typography>

              {/* Sección de Itinerario */}
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Datos de la Solicitud
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Typography variant="body1"><strong>Tutor:</strong> {detalleData.itinerario.nombretutor}</Typography>
                  <Typography variant="body1"><strong>Email Tutor:</strong> {detalleData.itinerario.mailtutor}</Typography>
                  <Typography variant="body1"><strong>Objetivo General:</strong> {detalleData.itinerario.objgeneral}</Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography variant="body1"><strong>Tema de Investigación:</strong> {detalleData.itinerario.temainv}</Typography>
                  <Typography variant="body1"><strong>Resultados:</strong> {detalleData.itinerario.resultados}</Typography>
                  <Typography variant="body1"><strong>Productos:</strong> {detalleData.itinerario.productos}</Typography>
                </Grid>
              </Grid>

              {/* Sección de Objetivos */}
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Objetivos Específicos
              </Typography>
              <List>
                {detalleData.objespecificos.map((objetivo, index) => (
                  <ListItem key={objetivo.iddecinvproyectotesistaobjespec}>
                    <Typography variant="body1"><strong>{index + 1})</strong> {objetivo.objespec}</Typography>
                  </ListItem>
                ))}
              </List>

              {/* Sección de Cronograma */}
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Cronograma de Actividades
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Actividad</TableCell>
                      <TableCell>Fecha de Inicio</TableCell>
                      <TableCell>Fecha de Fin</TableCell>
                      <TableCell>Presencial</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {detalleData.cronograma.map((item) => (
                      <TableRow key={item.iddecinvproyectotesistacronograma}>
                        <TableCell>{item.actividad}</TableCell>
                        <TableCell>{new Date(item.fechainicio).toLocaleDateString()}</TableCell>
                        <TableCell>{new Date(item.fechafin).toLocaleDateString()}</TableCell>
                        <TableCell>{item.presencial ? 'Sí' : 'No'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
          : <></>
        }
        </>}
      />
      <SmallModal
        title='Eliminar Solicitud'
        open={isModalEliminar}
        onClose={handleCloseModalEliminar}
        content={<>{detalleData.TituloProyecto !== ''
          ?
          <Card sx={{ margin: 2 }}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                {detalleData.TituloProyecto}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                Código del Proyecto: {detalleData.codigoProyecto}
              </Typography>

              {/* Sección de Itinerario */}
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Datos de la Solicitud
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Typography variant="body1"><strong>Tutor:</strong> {detalleData.itinerario.nombretutor}</Typography>
                  <Typography variant="body1"><strong>Email Tutor:</strong> {detalleData.itinerario.mailtutor}</Typography>
                  <Typography variant="body1"><strong>Objetivo General:</strong> {detalleData.itinerario.objgeneral}</Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography variant="body1"><strong>Tema de Investigación:</strong> {detalleData.itinerario.temainv}</Typography>
                  <Typography variant="body1"><strong>Resultados:</strong> {detalleData.itinerario.resultados}</Typography>
                  <Typography variant="body1"><strong>Productos:</strong> {detalleData.itinerario.productos}</Typography>
                </Grid>
                <Grid item xs={12}
                  sm={12}
                  container // Añadir esto para activar el comportamiento de flexbox en el Grid
                  direction="row"
                  justifyContent="flex-end" // Cambiado a 'flex-end' para alinear a la derecha
                  alignItems="center"
                >
                  <Button variant="contained" style={{ backgroundColor: 'red', color: 'white' }} onClick={() => { EliminarItinerario(detalleData.itinerario.iddecinvproyectotesista) }}>
                    Eliminar
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          : <></>
        }
        </>}
      />
      <SmallModal
        title='Editar Solicitud'
        open={isModalEditar}
        onClose={handleCloseModalEditar}
        content={<>{detalleData.TituloProyecto !== ''
          ?
          <Card sx={{ margin: 2 }}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                {detalleData.TituloProyecto}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                <strong>Código del Proyecto:</strong> {detalleData.codigoProyecto}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                <strong>Estudiante:</strong> {estudiante.nombre + " - " + estudiante.matricula}
              </Typography>
              <ItinerarioForm token={token} idProyecto={detalleData.itinerario.iddecinvproyecto} estudiante={estudiante} onResponse={handleResponseForm} SolicitudItinerario={detalleData} />
            </CardContent>
          </Card>
          : <></>
        }
        </>}
      />
    </Paper>
  );
}